<mat-card
    style="box-shadow: none; padding: 0px !important;"
    [class.mat-elevation-z1]="'true'"
>
    <mat-card-header>
        <mat-card-title>
            {{ readOnly ? 'View Ticket' : 'Log Ticket' }}
        </mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-dialog-content
        class
        style="display: grid !important;"
    >
        <mat-form-field
            class="custom-spacing"
            style="width: 50%; padding-top: 15px;"
        >
            <mat-label>Ticket Type</mat-label>
            <mat-select
                [(ngModel)]="ticketTypeId"
                (selectionChange)="ngOnChanges()"
                [disabled]="readOnly"
            >
                <mat-option
                    *ngFor="let option of ticketTypesList"
                    [value]="option.id"
                >
                    {{ option.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- description -->
        <mat-form-field style="width: 100%;">
            <mat-label>Title</mat-label>
            <input
                matInput
                [(ngModel)]="description"
                [disabled]="readOnly"
            >
        </mat-form-field>
        <!-- long description -->
        <mat-form-field style="width: 100%;">
            <mat-label style="padding: 5px;">Description</mat-label>
            <textarea
                matInput
                class="textinputupdate"
                [(ngModel)]="longDescription"
                [disabled]="readOnly"
            ></textarea>
        </mat-form-field>
        <mat-form-field *ngIf="readOnly" style="width: 100%;">
            <mat-label style="padding: 5px;">Comments</mat-label>
            <textarea
                matInput
                class="textinputupdate"
                [(ngModel)]="comments"
                [disabled]="readOnly"
            ></textarea>
        </mat-form-field>
        <!-- attachment field -->
        <mat-form-field>
            <label>Attachment:</label>
            <input
                matInput
                type="file"
                style="margin-top: 10px;"
                [(ngModel)]="attachment"
                (change)="onFileSelected($event)"
                [disabled]="readOnly"
            >
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions style="display: flex; justify-content: center;">
        <button
            style="font-size: 10px; margin-right: 5px; scale: 1; background: #bf1e2e; color: white; border-radius: 0px; text-shadow: none; box-shadow: none; flex: 1 1 100%; box-sizing: border-box; max-width: 50px; cursor: pointer; transition: background-color 0.3s;"
            mat-raised-button
            (click)="onCancelClick()"
        >
            Close
        </button>
        <button
            style="font-size: 10px; margin-right: 5px; scale: 1; background: #007bff; color: white; border-radius: 0px; text-shadow: none; box-shadow: none; flex: 1 1 100%; box-sizing: border-box; max-width: 50px; cursor: pointer; transition: background-color 0.3s;"
            mat-raised-button
            (click)="onSubmit()"
            [disabled]="readOnly"
        >
            Submit
        </button>
    </mat-dialog-actions>
</mat-card>
